// import React, { useEffect } from 'react';
// import { useJsApiLoader } from '@react-google-maps/api';
//
// const MapComponent: React.FC = () => {
//
//   const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
//
//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: apiKey || '',
//     libraries: ['places'], // Load the Places library
//   });
//
//
//   useEffect(() => {
//     if (isLoaded) {
//       test();
//     }
//   }, [isLoaded]);
//
//
//   const test = async () => {
//
//
//     // address.addListener("place_changed", () => {
//     //   const place:any = address.getPlace();
//     //   if (!place.geometry || !place.geometry.location) {
//     //     window.alert("No details available for input: '" + place.name + "'");
//     //     return;
//     //   }
//     //   const location = place.geometry.location;
//     //
//     //   // resolveAddressFromCoordinates(location.lat(), location.lng()).then(
//     //   //   (address) => {
//     //   //     origin_address.lat = location.lat();
//     //   //     origin_address.lng = location.lng();
//     //   //     origin_address.address = address;
//     //   //   }
//     //   // );
//     // });
//
//
//   };
//
//
//   // const [markerPosition, setMarkerPosition] = useState(initialCenter);
//   // const googleMapsApiKey = process.env.REACT_APP_GOOGLE_API_KEY || 'YOUR_DEFAULT_API_KEY';
//   //
//   // const handleMarkerDragEnd = (event: google.maps.MapMouseEvent) => {
//   //   const latLng = event.latLng;
//   //   if (latLng) {
//   //     setMarkerPosition({
//   //       lat: latLng.lat(),
//   //       lng: latLng.lng()
//   //     });
//   //     console.log('Marker dragged to:', latLng.lat(), latLng.lng());
//   //   }
//   // };
//   //
//   // if (!googleMapsApiKey) {
//   //   console.error('Google Maps API key is missing');
//   //   return <div>Error: Google Maps API key is missing</div>;
//   // }
//
//
//   return (
//     <div>
//       {/*<input*/}
//       {/*  id="origin_address_search"*/}
//       {/*  type="text"*/}
//       {/*  placeholder="search"*/}
//       {/*  style={{ width: '100%', padding: '8px', fontSize: '16px' }}*/}
//       {/*/>*/}
//     </div>
//
//   );
// };
//
// export default React.memo(MapComponent);
//
//
//
//
//

import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Paper,
  Switch,
  TextField,
  Typography,
  FormControlLabel,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

function QDeliveryTokenPage() {
  const [automaticCourier, setAutomaticCourier] = useState(true);
  const [orderPulling, setOrderPulling] = useState(true);
  const [automaticAssignment, setAutomaticAssignment] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleActivateToken = () => {
    setShowSettings(true);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          marginBottom: '32px',
        }}
      >
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: '50%',
            backgroundColor: '#E0F7FA',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" color="primary">
            Q
          </Typography>
        </Box>
        <Typography variant="h6" ml={2}>
          QDelivery
        </Typography>
      </Paper>

      {/* Token ekleme formu */}
      <Paper elevation={3} sx={{ p: 4, marginBottom: '32px' }}>
        <Typography variant="h6" gutterBottom>
          Token Ekle
        </Typography>

        <TextField
          label="Token"
          placeholder="QDelivery Token"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleActivateToken}
                >
                  Aktif Et
                </Button>
              </InputAdornment>
            ),
          }}
        />
        {showSettings && (
          <>
            <Box sx={{ display: 'grid' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={automaticCourier}
                    onChange={() => setAutomaticCourier(!automaticCourier)}
                    color="success"
                  />
                }
                label="Otomatik Kurye Oluşturma"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={orderPulling}
                    onChange={() => setOrderPulling(!orderPulling)}
                    color="success"
                  />
                }
                label="Sipariş Çekme / İletme"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={automaticAssignment}
                    onChange={() =>
                      setAutomaticAssignment(!automaticAssignment)
                    }
                    color="default"
                  />
                }
                label="Otomatik Atama"
              />
            </Box>

            <Divider sx={{ marginBottom: '30px', marginTop: '30px' }} />
            <Typography variant="h6" gutterBottom>
              Platform Entegrasyonları
            </Typography>
            <TextField
              label="Yemek Sepeti Go, Getir, Trendyol Gb."
              placeholder="Yemek Sepeti Go, Getir, Trendyol Gb."
              variant="outlined"
              disabled
              fullWidth
              sx={{ mb: 2 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={handleOpenModal}
                      variant="contained"
                      color="success"
                    >
                      Bağlan
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </>
        )}
      </Paper>
      <Button
        variant="contained"
        color="success"
        sx={{ display: 'flex', marginLeft: 'auto' }}
      >
        Kaydet
      </Button>
      <Dialog open={openModal} onClose={handleCloseModal} fullScreen>
        <DialogTitle>Qdelivery</DialogTitle>
        <DialogContent>
          <iframe
            src="https://dashboard.dev.qdelivery.app/kuik-q"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="Uygulamalar"
          />
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseModal}
            sx={{ mt: 2 }}
          >
            Geri Al
          </Button>
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default QDeliveryTokenPage;
